// Shared helpers for the Site Content tabs (PCP + PDP).
import { getActiveEnv, bcStoreForEnv } from '../../services/env';
import { getAccessToken } from '../../services/auth';

export const BASE_URL = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8888/.netlify/functions'
  : '/.netlify/functions';
export const BC_URL = BASE_URL + '/bc-proxy';
export const UPLOAD_CATEGORY_URL = BASE_URL + '/upload-category-image';
export const UPLOAD_PRODUCT_URL = BASE_URL + '/upload-product-image';
export const UPLOAD_MARQUEE_ICON_URL = BASE_URL + '/upload-marquee-icon';
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
export const MAX_MARQUEE_ICON_BYTES = 512 * 1024;

export async function bcApi(method, path, body) {
  return bcApiStore(bcStoreForEnv(getActiveEnv()), method, path, body);
}

// Same as bcApi but targets an explicit bc-proxy `store` string
// ('sandbox-2' / 'sandbox-1' / 'production') regardless of the active env.
// Used by the Grid Row Tags dual-write to mirror the edit to PROD.
export async function bcApiStore(store, method, path, body) {
  const token = getAccessToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(BC_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ method, path, body, store }),
  });
  const text = await res.text();
  let data = null;
  if (text) {
    try { data = JSON.parse(text); } catch { data = text; }
  }
  if (!res.ok) {
    const detail = data?.errors ? JSON.stringify(data.errors) : data?.title || data?.error || (typeof data === 'string' ? data : 'BC API error');
    throw new Error(detail);
  }
  return data;
}

export async function fetchAllPages(basePath) {
  let page = 1;
  let all = [];
  while (true) {
    const sep = basePath.includes('?') ? '&' : '?';
    const res = await bcApi('GET', `${basePath}${sep}page=${page}&limit=250`);
    const items = res?.data || [];
    all = all.concat(items);
    if (!res?.meta?.pagination || page >= res.meta.pagination.total_pages) break;
    page++;
  }
  return all;
}

export async function inBatches(items, size, fn) {
  const out = [];
  for (let i = 0; i < items.length; i += size) {
    const chunk = items.slice(i, i + size);
    const results = await Promise.all(chunk.map(fn));
    out.push(...results);
  }
  return out;
}

export function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error || new Error('Read failed'));
    reader.readAsDataURL(file);
  });
}
